import { render, staticRenderFns } from "./organization.vue?vue&type=template&id=da5811da&scoped=true&"
import script from "./organization.vue?vue&type=script&lang=js&"
export * from "./organization.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da5811da",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/imc/portal/dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('da5811da')) {
      api.createRecord('da5811da', component.options)
    } else {
      api.reload('da5811da', component.options)
    }
    module.hot.accept("./organization.vue?vue&type=template&id=da5811da&scoped=true&", function () {
      api.rerender('da5811da', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/js/components/shared/users/organization.vue"
export default component.exports